<div class="filter-tag"  *ngIf="control.value !== defaultValue">
    {{title}} : {{control.value}} <a (click)="onClickResetControl($event)" class="remove" title="Eliminar">×</a>
</div>
